import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import translation_en_US from './locales/en_US.json'
import translation_ja_JP from './locales/ja_JP.json'
import translation_ko_KR from './locales/ko_KR.json'
import translation_zh_CH from './locales/zh_CH.json'
import translation_zh_TW from './locales/zh_TW.json'

// https://qiita.com/Syoitu/items/98343af1bd69e7c38283
// MEMO: locales/*.jsonのキーは仮で作成しているので、名前の統一などはできていない
//  かつ、キーの階層なども考慮できないないので、よりよりキーの階層があればそちらに合わせる
// MEMO: 注意点として、言語が増えた場合には以下のresourcesに追加する必要がある。
//  ja_JPとen_US以外は管理画面で追加修正するようにするので、ローカルでの確認などをする想定はしていない。
//  加えて、resources以外に書かれている内容は読み込めないので、新規言語を追加する場合には以下に追記する必要がある。

i18n
  .use(initReactI18next)
  .use(LanguageDetector) // ユーザーの言語設定を検知するために必要
  .init({
    fallbackLng: 'ja_JP', // デフォルトの言語を設定
    returnEmptyString: false, // 空文字での定義を許可に
    resources: {
      // 辞書情報
      // 用意した翻訳ファイルを読み込む
      en_US: {
        translation: translation_en_US,
      },
      ja_JP: {
        translation: translation_ja_JP,
      },
      zh_TW: {
        translation: translation_zh_TW,
      },
      zh_CH: {
        translation: translation_zh_CH,
      },
      ko_KR: {
        translation: translation_ko_KR,
      },
    },
    interpolation: {
      // 翻訳された文字列内のHTMLやReactコンポーネントをエスケープすることを無効に
      escapeValue: false,
    },
    react: {
      // 指定したHTMLノードを翻訳時にそのまま保持して表示するための設定
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span'],
    },
  })

export default i18n
